<template>
    <div class="impact-brief-wizard">
        <pendo-drawer
            :visible="visible"
            class-name="impact-brief-wizard-drawer"
            placement="bottom"
            size="fullscreen"
            @closed="$emit('hideWizard')">
            <template #header>
                <div class="impact-brief-wizard-header">
                    <h4 class="title">
                        {{ wizardTitleText }}
                    </h4>
                    <div class="steps">
                        <template
                            v-for="(step, index) in steps"
                            :key="step.name">
                            <p
                                class="step"
                                :class="{ active: activeStep === step.name }">
                                {{ step.label }}
                            </p>
                            <pendo-icon
                                v-if="index < steps.length - 1"
                                size="12"
                                type="chevron-right" />
                        </template>
                    </div>
                    <pendo-button
                        type="secondary"
                        @click="$emit('exitClicked')">
                        Exit
                    </pendo-button>
                </div>
            </template>
            <template #body>
                <slot name="body" />
            </template>
            <template #footer>
                <div
                    v-if="showNavControls && activeStep !== 'initiatives'"
                    class="nav-controls">
                    <pendo-button
                        v-if="!hideBackButton"
                        type="secondary"
                        :disabled="isLoading"
                        @click="$emit('prevStep')">
                        Back
                    </pendo-button>
                    <pendo-button
                        data-cy="next-step-button"
                        :disabled="disableNextButton"
                        :loading="isLoading"
                        :pendo-analytics="nextButtonCySelector"
                        :prefix-icon="activeStep === 'preview' ? 'file-text' : ''"
                        :label="nextButtonDynamicText"
                        @click="$emit('nextStep')" />
                </div>
            </template>
        </pendo-drawer>
    </div>
</template>

<script>
import { PendoDrawer, PendoButton, PendoIcon } from '@pendo/components';

export default {
    name: 'ImpactBriefWizard',
    components: {
        PendoDrawer,
        PendoButton,
        PendoIcon,
    },
    props: {
        showNavControls: {
            type: Boolean,
            default: true,
        },
        nextButtonCySelector: {
            type: String,
            default: 'next-step-button',
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        disableNextButton: {
            type: Boolean,
            default: false,
        },
        activeStep: {
            type: String,
            default: '',
        },
        visible: {
            type: Boolean,
            default: false,
        },
        steps: {
            type: Array,
            default: () => [],
        },
    },
    emits: ['hideWizard', 'nextStep', 'prevStep', 'exitClicked'],
    computed: {
        nextButtonDynamicText () {
            const currentStepIndex = this.steps.findIndex((step) => step.name === this.activeStep);
            const nextStepIndex = currentStepIndex + 1;

            if (nextStepIndex < this.steps.length) {
                const nextStepName = this.steps[nextStepIndex].label;

                return `Next: ${nextStepName}`;
            }

            return 'Download Word document (.docx)';
        },
        hideBackButton () {
            return this.activeStep === this.steps[0].name;
        },
        wizardTitleText () {
            return 'Measure your success';
        },
    },
};
</script>

<style lang="less" scoped>
.impact-brief-wizard-header {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
}

.title {
    font-weight: 600;
}

.steps {
    display: flex;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    gap: 12px;
    justify-content: space-between;
    align-items: center;

    .step {
        margin: 0;

        &.active {
            font-weight: 600;
        }
    }
}
.nav-controls {
    text-align: right;
}
.button-content {
    display: flex;
    align-items: center;
    gap: 8px;
}
</style>
<!-- eslint-disable vue-scoped-css/enforce-style-type -->
<style lang="less">
.impact-brief-wizard-drawer {
    .pendo-drawer__body {
        padding-top: 0px;
        padding-bottom: 0px;
    }
}
</style>
